export default {
  state: {
    charter: {
      enabled: false,
      pickup: {},
      startDate: '',
      endDate: '',
      airportGeoId: ''
    }
  },
  mutations: {
    setCharterData (state, data) {
      for (let field in data) {
        state.charter[field] = data[field]
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/reservation-details/charter.js